<div class="vechile-storage-summary-title">{{ 'vehicleStorageOrigin' | translate }}</div>
<div class="vehicle-storage-card w-100 mt-2" *ngIf="vehicleStorageOrigin">
    <div class="not-checked">
        <!-- <div class="premium-label-box d-flex gap-1">
            <div class="premium-label" *ngIf="true">
                {{ 'cover' | translate }}
            </div>
            <div class="premium-label" *ngIf="!true">
                {{ 'openAir' | translate }}
            </div>
        </div> -->
        <div class="d-flex flex-row gap-1 mt-2">
            <div class="d-flex flex-column w-100 gap-2">
                <div class="d-flex flex-row justify-content-between">
                    <div class="vehicle-storage-name">
                        {{ vehicleStorageOrigin.vehicleStorageName }}
                    </div>
                </div>
                <div class="d-flex f-row gap-2 vehicle_storage_info">
                    <img src="/assets/icons/location-icon.svg" alt="" />
                    <span class="vehicle_storage_city">{{ vehicleStorageOrigin.city
                        }}</span>&nbsp;-&nbsp;
                    <span>{{ vehicleStorageOrigin.address }}</span>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="vechile-storage-summary-title mt-4">{{ 'vehicleStorageDestination' | translate }}</div>
<div class="vehicle-storage-card w-100 mt-4" *ngIf="vehicleStorageDestination">
    <div class="not-checked">
        <div class="premium-label-box d-flex gap-1">
            <div class="premium-label" *ngIf="vehicleStorageDestination.IsCover">
                {{ 'cover' | translate }}
            </div>
            <div class="premium-label" *ngIf="!vehicleStorageDestination.IsCover">
                {{ 'openAir' | translate }}
            </div>
        </div>
        <div class="d-flex flex-row gap-1 mt-2">
            <div class="d-flex flex-column w-100 gap-2">
                <div class="d-flex flex-row justify-content-between">
                    <div class="vehicle-storage-name">
                        {{ vehicleStorageDestination.Name }}
                    </div>
                </div>
                <div class="d-flex f-row gap-2 vehicle_storage_info">
                    <img src="/assets/icons/location-icon.svg" alt="" />
                    <span class="vehicle_storage_city">{{ vehicleStorageDestination.City
                        }}</span>&nbsp;-&nbsp;
                    <span>{{ vehicleStorageDestination.Address }}</span>
                </div>
            </div>
        </div>
    </div>
</div>